<template>
  <v-container
    fill-height
    fluid
    class="background"
    style="margin: 0px; padding: 0px; width: 100%"
  >
    <v-layout
      align-center
      justify-center>
      <v-flex
        xs12
        sm8
        md6>
        <v-card
          max-height="800px"
          class="elevation-12">
          <v-toolbar color="heron_toolbar">
            <v-avatar
              color="tranparent"
              size="70">
              <img src="../assets/img/energy-control.png" >
            </v-avatar>
            <v-toolbar-title
              class="toolbar_text--text"
            >Energy Control</v-toolbar-title
            >
            <v-spacer />
            <img
              src="../assets/img/heron_icon.svg"
              width="70" >
          </v-toolbar>
          <v-card-title class="title font-weight-bold">
            <v-spacer />
            Συγκατάθεση Χρήσης Προσωπικών Δεδομένων (2/2)
            <v-spacer />
            <a
              href="../../static/consentTerms.pdf"
              download>
              <v-icon
                color="blue darken-2"
                large>mdi-download</v-icon>
            </a>
          </v-card-title>
          <v-card-text @scroll="handleScroll">
            <pdf
              v-for="i in 2"
              :style="{ width: zoom_string }"
              :key="i"
              :page="i"
              src="../../static/consentTerms.pdf"
            />
            <v-flex xs12>
              <v-checkbox
                v-model="acceptExtraTermsCheckbox"
                :disabled="checkboxesDisabled"
                class="highlight--text mb-0"
                color="#323d77"
                label="Ναι, επιτρέπω στην Εταιρεία να χρησιμοποιεί τα προσωπικά μου δεδομένα στο πλαίσιο των ως άνω αναφερόμενων και απολύτως αναλόγων επιστημονικών ερευνών και προς εξυπηρέτηση των σκοπών τους."
                @change="checkYes($event)"
              />
              <v-checkbox
                v-model="rejectExtraTermsCheckbox"
                :disabled="checkboxesDisabled"
                class="fostSize--text mt-0"
                color="#323d77"
                label="Όχι, δεν επιτρέπω στην Εταιρεία να χρησιμοποιεί τα προσωπικά μου δεδομένα στο πλαίσιο των ως άνω αναφερόμενων και απολύτως αναλόγων επιστημονικών ερευνών και προς εξυπηρέτηση των σκοπών τους."
                @change="checkNo($event)"
              />
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-container
              grid-list-md
              text-xs-center>
              <v-layout
                row
                wrap>
                <v-flex xs12>
                  <v-icon
                    large
                    @click="zoomIn()"
                  >mdi-magnify-plus-outline</v-icon
                  >
                  <v-icon
                    large
                    @click="zoomOut()"
                  >mdi-magnify-minus-outline</v-icon
                  >
                </v-flex>
                <v-flex>
                  <v-btn
                    :disabled="submitButtonDisabled"
                    block
                    color="heron_success"
                    @click="update"
                  >
                    ενημερωση
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>

          <v-snackbar
            v-model="snackbar"
            :timeout="5000"
            :color="snackColor"
            :top="true"
          >
            {{ errorMessages }}
            <v-btn
              dark
              flat
              @click="snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
          <v-dialog
            v-model="consentSnackbar"
            width="700">
            <v-card
              min-height="300px"
              class="elevation-12">
              <v-toolbar color="heron_toolbar">
                <v-avatar
                  color="tranparent"
                  size="70">
                  <img src="../assets/img/energy-control.png" >
                </v-avatar>
                <v-toolbar-title
                  class="toolbar_text--text"
                >Energy Control</v-toolbar-title
                >
                <v-spacer />
                <img
                  src="../assets/img/heron_icon.svg"
                  width="70" >
              </v-toolbar>
              <v-card-title class="card-title">
                <v-icon
                  size="60"
                  color="error"
                  class="pr-4"
                >mdi-account-remove</v-icon
                >
                Για να ολοκληρωθεί η εγγραφή πρέπει να δώσετε τη συγκατάθεσή σας
                στην επεξεργασία των προσωπικών σας δεδομένων.
              </v-card-title>
              <v-card-actions>
                <v-spacer/>
                <v-btn
                  color="heron_success"
                  text
                  @click="consentSnackbar = false"
                >
                  OK
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  components: {
    pdf
  },
  data: () => ({
    acceptExtraTermsCheckbox: false,
    rejectExtraTermsCheckbox: false,
    submitButtonDisabled: true,
    checkboxesDisabled: true,
    termsCheckbox: false,
    errorMessages: '',
    snackbar: false,
    consentSnackbar: false,
    snackColor: '',
    color: 'general',
    checkboxError: false,
    zoom: 100,
    zoom_string: '100%',
    terms_token: ''
  }),

  created () {
    this.$store
      .dispatch('validateAcceptTermsToken', this.$route.query.token)
      .then((response) => {
        this.terms_token = this.$route.query.token
      })
      .catch((err) => {
        this.$router.push({
          name: 'token_expired'
        })
      })

    if (this.$route.params.data !== undefined) {
      this.termsCheckbox =
        this.$route.params.data !== undefined
          ? this.$route.params.data.termsCheckbox
          : false
    } else {
      this.$router.push({
        name: 'accept_terms',
        query: { token: this.$route.query.token }
      })
    }
  },

  methods: {
    zoomIn () {
      this.zoom += 10
      this.zoom_string = this.zoom.toString() + '%'
    },

    zoomOut () {
      this.zoom -= 10
      this.zoom_string = this.zoom.toString() + '%'
    },
    checkYes: function (isChecked) {
      if (isChecked) {
        this.rejectExtraTermsCheckbox = false
        this.submitButtonDisabled = false
      } else {
        this.submitButtonDisabled = true
      }
    },
    checkNo: function (isChecked) {
      if (isChecked) {
        this.acceptExtraTermsCheckbox = false
        this.submitButtonDisabled = true
        this.consentInline()
      } else {
        this.submitButtonDisabled = true
      }
    },
    handleScroll (e) {
      if (
        e.target.offsetHeight + e.target.scrollTop >=
        e.target.scrollHeight - 700
      ) {
        this.checkboxesDisabled = false
      }
    },
    update () {
      if (
        this.acceptExtraTermsCheckbox == false &&
        this.rejectExtraTermsCheckbox == false
      ) {
        this.termsAndConditionsInline()
      } else {
        let termsCheckbox = this.termsCheckbox
        let extraTermsCheckbox = this.acceptExtraTermsCheckbox
          ? this.acceptExtraTermsCheckbox
          : false
        let terms_token = this.$route.query.token

        this.$store
          .dispatch('updateTerms', {
            termsCheckbox,
            extraTermsCheckbox,
            terms_token
          })
          .then((response) => {
            setTimeout(() => {
              this.$router.push({
                name: 'terms_updated'
              })
            }, 1000)
          })
          .catch((err) => {
            this.apiErrorInline()
          })
      }
    },
    termsAndConditionsInline () {
      this.snackbar = true
      this.snackColor = 'error'
      this.errorMessages =
        'Πρέπει να αποδεχτείτε τηn επεξεργασία των προσωπικών σας δεδομένων'
    },
    apiErrorInline () {
      this.snackbar = true
      this.snackColor = 'error'
      this.errorMessages =
        'Παρουσιάστηκε σφάλμα κατά την εκτέλεση του αιτήματος'
    },
    userExistsErrorInline () {
      this.snackbar = true
      this.snackColor = 'error'
      this.errorMessages = 'Ο χρήστης υπάρχει ήδη'
    },
    consentInline () {
      this.consentSnackbar = true
    }
  },
  metaInfo () {
    return {
      title: 'HERON Energy Control'
    }
  }
}
</script>

<style scoped>
.background {
  background: url("../assets/img/heron_background_new.jpg");
  background-size: cover;
  width: 100%;
  height: 100%;
}
.v-card {
  display: flex !important;
  flex-direction: column;
}
.v-card__text {
  flex-grow: 1;
  overflow: auto;
}
.highlight--text /deep/ label {
  color: #323d77;
  font-size: 15px;
}
.fostSize--text /deep/ label {
  font-size: 15px;
}
.v-toolbar__title {
  font-size: 1.5rem !important;
}
</style>
